<template>
  <ValidationObserver v-slot="{ invalid }">
    <div class="vx-row">
      <!------------------------------------------ Left Side ---------------------------------------------------------->
      <div class="vx-col sm:w-2/5 w-full mi-border-right">

        <div class="vx-row">
          <div class="vx-col w-1/2 pt-1">
            <h5> {{ $t('vdo-set.vdo-set-topic') }} </h5>
          </div>

          <div class="vx-col w-1/2 pr-5">
            <vx-tooltip :text="$t('general.add') + $t('vdo-set.vdo-set-topic')" class="float-right">
              <vs-button :disabled="isUploading" color="dark" icon="icon-plus" icon-pack="feather" radius size="small"
                         type="border" @click="onAddClick">
              </vs-button>
            </vx-tooltip>
          </div>

        </div>

        <div class="vs-row">
          <VuePerfectScrollbar :settings="settings">
            <div class="vx-col w-full" style="height: 500px;">
              <vs-list>
                <vs-list-item v-for="(item, index) in vdoSetTopics" :key="index"
                              :class="setSelectedClass(item)"
                              :icon="item.vdoLength > 0 ? 'icon-video':'icon-video-off'"
                              :subtitle="setVdoLengthLabel(item.vdoLength)"
                              :title="item.no + '. ' +item.nameLocal"
                              class="hover:text-primary pr-1"
                              icon-pack="feather">


                  <div class="flex">
                    <vx-tooltip v-if="!item.isEnabled"
                                :text="$t('vdo-set-topic.disabled')">
                      <feather-icon class="mr-1" icon="XIcon"
                                    svgClasses="w-5 h-5 text-danger stroke-current"/>
                    </vx-tooltip>
                    <vx-tooltip v-if="item.vdoStreamPath"
                                :text="$t('vdo-set-topic.preview')">
                      <feather-icon class="cursor-pointer mr-1" icon="PlayIcon"
                                    svgClasses="w-5 h-5 hover:text-primary stroke-current"
                                    @click="onPreviewVideoClick(item)"/>
                    </vx-tooltip>
                    <vx-tooltip v-if="showDownload && item.vdoStreamPath"
                                :text="$t('vdo-set-topic.download-vdo')">
                      <feather-icon class="cursor-pointer mr-1" icon="DownloadIcon"
                                    svgClasses="w-5 h-5 hover:text-primary stroke-current"
                                    @click="onDownloadVideoClick(item)"/>
                    </vx-tooltip>
                    <vx-tooltip :text="$t('general.edit') + $t('vdo-set.vdo-set-topic')">
                      <feather-icon class="cursor-pointer" icon="EditIcon"
                                    svgClasses="w-5 h-5 hover:text-primary stroke-current"
                                    @click="onEditClick(item)"/>
                    </vx-tooltip>
                  </div>

                </vs-list-item>
              </vs-list>
              <vs-alert :active="showWarningNoTopics" color="warning" icon="icon-alert-triangle" icon-pack="feather">
                {{ $t('vdo-set-topic.no-vdo-set-topic') }}
              </vs-alert>
            </div>
          </VuePerfectScrollbar>
        </div>

      </div>

      <!------------------------------------------ Right Side --------------------------------------------------------->
      <div class="vx-col sm:w-3/5 w-full">
        <!-- PREVIEW VIDEO WHEN CLICK FROM LEFT SIDE-->
        <template v-if="currentVdoSetTopic && showPreviewVideo">
          <div class="vs-row">
            <div class="vx-col w-full mb-2">
              <div class="flex justify-between align-items-center">
                <h5 class="pt-2"> {{ $t('vdo-set-topic.preview-video-title') }} </h5>

                <vx-tooltip :text="$t('vdo-set-topic.stop-preview')">
                  <vs-button :disabled="local.isProcessing || isUploading"
                             color="danger"
                             radius type="border"
                             icon="close"
                             size="small"
                             @click.prevent="onTriggerPreviewClick(false)">
                  </vs-button>
                </vx-tooltip>
              </div>
            </div>
          </div>

          <vs-divider/>

          <div class="vx-row">
            <div class="vx-col w-full mb-2">
              <preview-video-card :current-vdo-set-topic="currentVdoSetTopic"></preview-video-card>
            </div>
          </div>
        </template>
        <!-- UPLOAD LEARN TIME FORM -->
        <template v-else-if="showUploadLearnTime && currentVdoSetTopic">
          <div class="vs-row">
            <div class="vx-col w-full mb-2">
              <div class="flex justify-between align-items-center">
                <h5 class="pt-2"> {{ $t('vdo-set-topic.upload-learn-time') }} </h5>

                <vx-tooltip :text="$t('general.close')">
                  <vs-button :disabled="local.isProcessing || isUploading"
                             color="danger"
                             radius type="border"
                             icon="close"
                             size="small"
                             @click.prevent="closeUploadLearnTimeCard">
                  </vs-button>
                </vx-tooltip>
              </div>
            </div>
          </div>

          <vs-divider/>
          <div class="vs-row">
            <div class="vx-col w-full mb-2">
              <upload-learn-time-card
                :vdo-set="vdoSetInfo.selectedVdoSet"
                :vdo-set-unit="vdoSetUnitEdit.selectedVdoSetUnit"
                :vdo-set-topic="currentVdoSetTopic"
              >
              </upload-learn-time-card>
            </div>
          </div>
        </template>

        <!-- EDIT FORM-->
        <template v-else>

          <div class="vs-row mb-2">
            <div class="vx-col w-full">
              <h5> {{ vdoSetTopicFormHeader }} </h5>
            </div>
          </div>

          <vs-divider/>

          <vs-tabs v-model="selectedTab">
            <!---------------------- TOPIC DETAIL ------------------------>
            <vs-tab :label="$t('vdo-set-topic.topic-detail')">

              <div class="vx-row mb-2">
                <div class="vx-col sm:w-1/2 w-full">
                  <ValidationProvider v-slot="{ errors }" :name="$t('vdo-set-topic.no')" rules="required|numeric">
                    <vs-input v-model.number="form.vdoSetTopicInput.no" :label="$t('vdo-set-topic.no') + ' *'"
                              class="w-full"/>
                    <span v-show="errors[0]" class="text-danger text-sm">{{ errors[0] }}</span>
                  </ValidationProvider>
                </div>
              </div>

              <div class="vx-row mb-2">
                <div class="vx-col sm:w-1/2 w-full">
                  <ValidationProvider v-slot="{ errors }" :name="$t('vdo-set-topic.name-local')" rules="required">
                    <vs-input v-model="form.vdoSetTopicInput.nameLocal" :label="$t('vdo-set-topic.name-local') + ' *'"
                              class="w-full"/>
                    <span v-show="errors[0]" class="text-danger text-sm">{{ errors[0] }}</span>
                  </ValidationProvider>
                </div>
                <div class="vx-col sm:w-1/2 w-full">
                  <vs-input v-model="form.vdoSetTopicInput.nameEng" :label="$t('vdo-set-topic.name-eng')" class="w-full"/>
                </div>
              </div>

              <div class="vx-row mb-2">
                <div class="vx-col sm:w-1/2 w-full">
                  <ValidationProvider v-slot="{ errors }" :name="$t('vdo-set-topic.description-local')" rules="required">
                    <label class="text-sm">{{ $t('vdo-set-topic.description-local') + ' *' }}</label>
                    <vs-textarea v-model="form.vdoSetTopicInput.descriptionLocal" rows="2" class="mb-0"/>
                    <span v-show="errors[0]" class="text-danger text-sm">{{ errors[0] }}</span>
                  </ValidationProvider>
                </div>
                <div class="vx-col sm:w-1/2 w-full">
                  <label class="text-sm">{{ $t('vdo-set-topic.description-eng') }}</label>
                  <vs-textarea v-model="form.vdoSetTopicInput.descriptionEng" rows="2"/>
                </div>
              </div>

              <div class="vx-row mb-2">
                <div class="vx-col w-full">
                  <label class="text-sm">{{ $t('vdo-set-topic.remark') }}</label>
                  <vs-textarea v-model="form.vdoSetTopicInput.remark" rows="2"/>
                </div>
              </div>

              <div class="vx-row mb-2">
                <div class="vx-col w-full">
                  <vs-checkbox v-model="form.vdoSetTopicInput.isEnabled" class="inline-flex">
                    {{ $t('vdo-set-topic.is-enabled') }}
                  </vs-checkbox>
                </div>
              </div>

              <!----------------------------------------- Actions Button ---------------------------------------------------->
              <div class="vx-row pt-2">
                <div class="vx-col sm:w-1/2 w-full">
                  <vs-button :disabled="local.isProcessing || invalid || isUploading"
                             @click.prevent="onSaveClick">
                    {{ $t('general.save') }}
                  </vs-button>
                  <vs-button v-if="showDeleteButton"
                             :disabled="local.isProcessing || isUploading"
                             class="ml-2" color="danger"
                             @click.prevent="onDeleteClick">
                    {{ $t('general.delete') }}
                  </vs-button>
                </div>
                <!--                  <div class="vx-col sm:w-1/2 w-full flex justify-end">
                                    <vs-button v-if="showDeleteButton"
                                               :disabled="local.isProcessing ||  invalid || isUploading"
                                               color="primary"
                                               @click.prevent="onUploadLearnTimeClick">
                                      <feather-icon icon="UploadIcon" svgClasses="h-4 w-4"></feather-icon>
                                      {{ $t('vdo-set-topic.upload-learn-time') }}
                                    </vs-button>
                                  </div>-->
              </div>
            </vs-tab>
            <!---------------------- UPLOAD VIDEO ------------------------>
            <vs-tab :label="$t('vdo-set-topic.video-topic')" :disabled="!showFileUpload">
              <div class="vx-row mb-2">
                <div class="vx-col w-full">
                  <borrowed-video-info :sharing="sharing"/>
                </div>
              </div>
              <div class="vx-row mb-2">
                <div class="vx-col sm:w-1/3 w-full">
                  <vs-button class="w-full"
                             type="border"
                             color="primary"
                             :disabled="local.isProcessing || isUploading || !currentVdoSetTopic"
                             @click.prevent="showBorrowDialog = true">
                    <feather-icon icon="LinkIcon" svgClasses="h-4 w-4"></feather-icon>
                    {{ $t('video-reuse.use-existing-video') }}
                  </vs-button>
                </div>
              </div>
              <div class="vx-row mb-2">
                <div class="vx-col w-full">
                  <vue-dropzone id="dropzone" ref="myVueDropzone"
                                :options="dropzoneOptions"
                                :useCustomSlot=true
                                @vdropzone-file-added="onFileUploadChange"
                                @vdropzone-success="onUploadSuccess"
                                @vdropzone-error="onUploadError"
                                @vdropzone-sending="sendingEvent">
                    <p class="text-lg text-success text-bold">{{ $t('vdo-set-topic.upload-vdo') }}</p>
                    <p class="text-sm">{{ $t('vdo-set-topic.drop-file-here') }}</p>
                  </vue-dropzone>
                </div>
              </div>
              <div class="vx-row mb-2">
                <div class="vx-col w-full" >
                  <template v-if="currentVdoSetTopic
                         && currentVdoSetTopic.vdoStreamPath
                         && !showPreviewVideo">
                    <div class="vx-row mb-2">
                      <div class="vx-col sm:w-1/4 w-full">
                        <vs-button :disabled="local.isProcessing || isUploading"
                                   class="w-full"
                                   color="success"
                                   @click.prevent="onTriggerPreviewClick(true)">
                          <feather-icon icon="PlayIcon" svgClasses="h-4 w-4"></feather-icon>
                          {{ $t('vdo-set-topic.preview') }}
                        </vs-button>
                      </div>
                      <div class="vx-col sm:w-1/4 w-full" v-if="showDownload">
                        <vs-button :disabled="local.isProcessing || isUploading"
                                   class="w-full"
                                   color="primary"
                                   @click.prevent="onDownloadVideoClick(currentVdoSetTopic)">
                          <feather-icon icon="DownloadIcon" svgClasses="h-4 w-4"></feather-icon>
                          {{ $t('general.download') }}
                        </vs-button>
                      </div>
                      <div class="vx-col sm:w-1/4 w-full">
                        <vs-button :disabled="local.isProcessing || isUploading"
                                   class="w-full"
                                   color="danger"
                                   @click.prevent="onDeleteVideoClick">
                          <feather-icon icon="TrashIcon" svgClasses="h-4 w-4"></feather-icon>
                          {{ $t('vdo-set-topic.delete-only-video') }}
                        </vs-button>
                      </div>
                      <div class="vx-col sm:w-1/4 w-full">
                        <vs-button v-if="showDeleteButton"
                                   :disabled="local.isProcessing ||  invalid || isUploading"
                                   color="primary"
                                   @click.prevent="onUploadLearnTimeClick">
                          <feather-icon icon="UploadIcon" svgClasses="h-4 w-4"></feather-icon>
                          {{ $t('vdo-set-topic.upload-learn-time') }}
                        </vs-button>
                      </div>
                    </div>
                    <div class="vx-row">
                      <div class="vx-col sm:w-1/4 w-full">
                        <vs-button :disabled="local.isProcessing || isUploading"
                                   class="w-full"
                                   color="warning"
                                   @click.prevent="onCheckVideoCorrupt(currentVdoSetTopic.vdoStreamPath)">
                          <feather-icon icon="CheckIcon" svgClasses="h-4 w-4"></feather-icon>
                          {{ $t('vdo-set-topic.check-vdo-corrupt') }}
                        </vs-button>
                      </div>
                    </div>
                  </template>
                </div>
              </div>

            </vs-tab>
            <!---------------------- UPLOAD THUMBNAIL ------------------------>
            <vs-tab :label="$t('vdo-set-topic.thumbnail')" :disabled="!showFileUpload">
              <div class="vx-row mb-2">
                <div class="vx-col sm:w-1/2 w-full text-center">
                  <img ref="have-avatar"
                       width="200"
                       height="112"
                       :src="thumbnailUrl"
                       style="display: block; margin-left: auto; margin-right: auto;"
                  />
                </div>
                <div class="vx-col sm:w-1/2 w-full">
                  <input type="file" class="hidden" ref="update_picture_input"
                         @change="uploadPictureChange"
                         accept="image/*">

                  <vs-button color="primary" icon-pack="feather" icon="icon-upload"
                             class="w-full"
                             @click="$refs.update_picture_input.click()">
                    {{ $t('course-outline.upload-course-picture') }}
                  </vs-button>

                  <p class="mt-2">{{ $t('vdo-set-topic.thumbnail-size') }}</p>
                  <p>{{ $t('vdo-set-topic.thumbnail-type') }}</p>
                </div>
              </div>
            </vs-tab>
          </vs-tabs>


        </template>

      </div>
    </div>

    <borrow-video-dialog :active.sync="showBorrowDialog"
                         :topic="currentVdoSetTopic"
                         @selected="onBorrowSelected"/>
  </ValidationObserver>
</template>

<script>
// import axios from "axios";
import axios from "@/setup/axios-setup";
// import * as crypto from "crypto";
// import CryptoJS from 'crypto-js';
import VueDropzone from 'vue2-dropzone';
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import 'vue2-dropzone/dist/vue2Dropzone.min.css';
import {setEmptyVdoSetTopicForm, state} from '../data';
import {secondToHHMMSSFormat} from "@/utils/data";
import {notificationType, showLocalNotification, showStateNotification} from "@/utils/notification";
// import {confirmDelete, confirmSave} from "@/utils/dialogs";
import {confirmDelete, successDialog, errorDialog, warningDialog} from "@/utils/dialogs";
import {config, getPhotoUrl} from "@/utils/upload";
// import vsUploadMod from '@/components/vuesax-mod/components/vsUpload/vsUpload'
import {getECode, getRStage, getToken} from "@/utils/auth-data";
import PreviewVideoCard from "@/views/pages/VdoSet/SubComponents/PreviewVideoCard";
import UploadLearnTimeCard from "@/views/pages/VdoSet/SubComponents/UploadLearnTimeCard";
import BorrowVideoDialog from './BorrowVideoDialog.vue';
import BorrowedVideoInfo from './BorrowedVideoInfo.vue';

import VdoSetTopic from '@/store/modules/vdo-set/vdo-set-topic/index';
import Upload from "@/store/modules/upload";
import {createHelpers} from 'vuex-map-fields';
import {createNamespacedHelpers} from "vuex";
import {isVideoDownloadEnabled} from '@/utils/video-provider';
import {withVdoLength} from '@/utils/vdo-length';
import BunnyUpload from '@/store/modules/vdo-set/bunny-upload';

if (!state.store.VdoSetTopic) state.registerModule(`VdoSetTopic`, VdoSetTopic);
if (!state.store.Upload) state.registerModule(`Upload`, Upload);
// Registered so this screen can route the delete path to deleteBunnyVideo
// (Finding 2) for a topic that borrowed a Bunny video -- this screen never
// uploads to Bunny itself, but it must be able to release a video it did
// not create.
if (!state.store.BunnyUpload) state.registerModule(`BunnyUpload`, BunnyUpload);

const {
  mapActions: mapVdoSetTopicActions,
} = createNamespacedHelpers(`VdoSetTopic`);
const {
  mapActions: mapUploadActions,
} = createNamespacedHelpers(`Upload`);
const {
  mapActions: mapBunnyUploadActions,
} = createNamespacedHelpers(`BunnyUpload`);

const {
  mapFields: mapVdoSetTopicFields,
} = createHelpers({
  getterType: `VdoSetTopic/getField`,
  mutationType: `VdoSetTopic/updateField`,
});


export default {
  components: {
    // vsUploadMod,
    VueDropzone,
    PreviewVideoCard,
    VuePerfectScrollbar,
    UploadLearnTimeCard,
    BorrowVideoDialog,
    BorrowedVideoInfo,
  },
  data() {
    return {
      settings: {      // perfectScrollbar settings
        maxScrollbarLength: 30,
        wheelSpeed: 1,
        wheelPropagation: false,
        swipeEasing: true
      },
      store: state.store,
      local: state.local,

      vdoSetEdit: state.local.vdoSetEdit,
      vdoSetInfo: state.local.vdoSetInfo,
      vdoSetUnitEdit: state.local.vdoSetUnitEdit,
      vdoSetTopicEdit: state.local.vdoSetTopicEdit,

      form: state.local.vdoSetTopicEdit.form,

      uploadAcceptVdoType: config.fileExtension.video,
      uploadVdoUrl: config.url.vdoOnDemandApi,
      uploadPayload: {
        fileName: '',
        vdoSetTopicId: '',
        subjectCode: '',
        vdoLength: 0,
        r_stage: getRStage,
        e_code: getECode,
        authorization: getToken,
        app: "admin",
        appName: "xstudi",
        checksum: null,
        teacherCode: '',
      },
      dropzoneOptions: {
        url: config.url.vdoOnDemandApi,
        paramName: 'vod',
        enctype: 'multipart/form-data',
        thumbnailHeight: 160,
        maxFilesize: 40930, // MB
        acceptedFiles: '.mov,.mp4,.m4a,.m4v,.3gp,.3g2,.mj2,.wav',
        maxFiles: 1,
        chunking: true,
        chunkSize: 3145728, // Bytes
        // 1 MB old = 1024000 bytes
        // 1 MB new = 1048576 bytes
        // 3 MB = 3145728 bytes
        // 5 MB = 5242880 bytes
        // 10 MB: 10485760 bytes
        // 20 MB: 20971520 bytes
        // 50 MB: 52428800 bytes
        // 1024000 * 5 =
        duplicateCheck: true,
        timeout: 1000 * 60 * 60 * 20, //2 hrs
        useCustomDropzoneOptions: true,
        headers: {
          'authorization': getToken,
        },
      },

      showPreviewVideo: false,
      loading: false,

      showBorrowDialog: false,
      // getVdoSetTopicSharing result for the topic on screen. Loaded on demand
      // rather than folded into getVdoSetTopic because videoSharedWith costs an
      // extra server query per topic.
      sharing: null,

      //for upload learn time
      showUploadLearnTime: false,

      //thumbnail
      fileUpload: null,
      allowWidth: 200,
      allowHeight: 112,
      fileWidth: 0,
      fileHeight: 0,

      selectedTab: 0,
    }
  },
  computed: {
    ...mapVdoSetTopicFields({
      vdoSetTopicProcessing: 'processing',
      vdoSetTopicSuccess: 'success',
      vdoSetTopicError: 'error'
    }),
    isUploading() {
      return this.local.isUploading
    },
    // Off with the Bunny screen's download, not because Wowza cannot serve the
    // file -- it can -- but so the two screens agree on whether the feature
    // exists. See isVideoDownloadEnabled.
    showDownload() {
      return isVideoDownloadEnabled();
    },
    vdoSetTopics() {
      return this.local.vdoSetUnitEdit.selectedVdoSetUnit ? this.local.vdoSetUnitEdit.selectedVdoSetUnit.vdoSetTopics : [];
    },
    vdoSetTopicFormHeader() {
      if (this.vdoSetTopicEdit.selectedVdoSetTopic) {
        return this.$t('general.edit') + this.$t('vdo-set.vdo-set-topic');
      } else {
        return this.$t('general.add') + this.$t('vdo-set.vdo-set-topic');
      }
    },
    showWarningNoTopics() {
      if (this.local.vdoSetUnitEdit.selectedVdoSetUnit
        && this.local.vdoSetUnitEdit.selectedVdoSetUnit.vdoSetTopics
        && this.local.vdoSetUnitEdit.selectedVdoSetUnit.vdoSetTopics.length > 0) {
        return false;
      }
      return true;
    },
    showFileUpload() {
      if (this.vdoSetTopicEdit.selectedVdoSetTopic && this.vdoSetTopicEdit.selectedVdoSetTopic.id) {
        return true;
      } else {
        return false;
      }
    },
    showDeleteButton() {
      if (this.vdoSetTopicEdit.selectedVdoSetTopic && this.vdoSetTopicEdit.selectedVdoSetTopic.id) {
        return true;
      } else {
        return false;
      }
    },
    currentVdoSetTopic() {
      if (this.vdoSetTopicEdit.selectedVdoSetTopic) {
        return this.vdoSetTopicEdit.selectedVdoSetTopic
      }
      return null;
    },
    thumbnailUrl() {
      if (this.fileUpload) {
        return URL.createObjectURL(this.fileUpload)
      }
      else if (!this.fileUpload && this.form.vdoSetTopicInput && this.form.vdoSetTopicInput.thumbnail) {
        return getPhotoUrl(this.form.vdoSetTopicInput.thumbnail);
      }
      else {
        return config.url.noPhotoImage;
      }
    },
  },
  watch: {
    vdoSetTopicProcessing(data) {
      this.local.isProcessing = data;
    },
    vdoSetTopicSuccess(data) {
      showStateNotification(this.$vs, data);
    },
    vdoSetTopicError(data) {
      showStateNotification(this.$vs, data);
    },
    loading(data) {
      this.local.isProcessing = data;
    },
    showFileUpload(value){
      if(!value){
        this.setTabDefaultPosition()
      }
    },
    currentVdoSetTopic: {
      immediate: true,
      handler() {
        this.loadSharing();
      },
    },
  },
  methods: {
    //---------------------------------------- State Function ------------------------------------------------------//
    ...mapVdoSetTopicActions({
      getVdoSetTopic: 'getVdoSetTopic',
      addVdoSetTopic: 'addVdoSetTopic',
      updateVdoSetTopic: 'updateVdoSetTopic',
      updateOnlyVdoSetTopic: 'updateOnlyVdoSetTopic',
      deleteVdoSetTopic: 'deleteVdoSetTopic',
      deleteOnlyVideo: 'deleteOnlyVideo',
      borrowVdoSetTopicVideo: 'borrowVdoSetTopicVideo',
      getVdoSetTopicSharing: 'getVdoSetTopicSharing',
    }),
    ...mapUploadActions({
      uploadAvatar: 'uploadAvatar',
    }),
    ...mapBunnyUploadActions(['deleteBunnyVideo']),
    //---------------------------------------- Event Function ------------------------------------------------------//
    onAddClick() {
      if (!this.local.isUploading) {
        this.setTabDefaultPosition();
        setEmptyVdoSetTopicForm();
        this.clearVideoUploadPayload();
        this.showPreviewVideo = false;
        this.showUploadLearnTime = false;
      }
    },
    onEditClick(selectedData) {
      if (!this.local.isUploading) {
        this.setTabDefaultPosition();
        this.showPreviewVideo = false;
        this.showUploadLearnTime = false;

        this.vdoSetTopicEdit.selectedVdoSetTopic = selectedData;

        this.form.vdoSetTopicInput.no = selectedData.no;
        this.form.vdoSetTopicInput.nameLocal = selectedData.nameLocal;
        this.form.vdoSetTopicInput.nameEng = selectedData.nameEng;
        this.form.vdoSetTopicInput.descriptionLocal = selectedData.descriptionLocal;
        this.form.vdoSetTopicInput.descriptionEng = selectedData.descriptionEng;
        this.form.vdoSetTopicInput.vdoLength = selectedData.vdoLength;
        this.form.vdoSetTopicInput.remark = selectedData.remark;
        this.form.vdoSetTopicInput.isEnabled = selectedData.isEnabled;
        this.form.vdoSetTopicInput.thumbnail = selectedData.thumbnail;

        //set id for api upload
        this.uploadPayload.vdoSetTopicId = selectedData.id;
        this.uploadPayload.subjectCode = this.vdoSetEdit.courseOutline.subject.code;
        this.uploadPayload.fileName = '';
        this.uploadPayload.fileNameUpload = '';
        this.uploadPayload.vdoLength = 0;
        this.uploadPayload.checksum = null;
        this.uploadPayload.teacherCode = this.vdoSetEdit.courseOutline.teacher.code;
      }
    },
    async onSaveClick() {
      let payload = this.prepareDataBeforeSave();
      // console.log('onSaveClick', payload);
      // confirmSave(this.$vs, this.saveVdoSetTopic, payload);

      await this.saveVdoSetTopic(payload);
    },
    async onDeleteClick() {
      let payload = {
        id: this.vdoSetTopicEdit.selectedVdoSetTopic.id
      }
      confirmDelete(this.$vs, this.removeVdoSetTopic, payload);
    },
    async onDeleteVideoClick() {
      let payload = {
        id: this.vdoSetTopicEdit.selectedVdoSetTopic.id
      }
      // This screen never had an explicit confirmMessage of its own -- it
      // relied on confirmDelete's generic default. Finding 5: that default is
      // built explicitly here so the shared-file sentence can be appended to
      // it rather than substituting for it (as before), which used to drop
      // the irreversibility framing exactly when a shared file was involved.
      const confirmMessage = this.$t('general.confirmDeleteMessage');
      const sharedMessage = this.sharedDeleteMessage();
      const finalMessage = sharedMessage ?
        `${confirmMessage || ''}\n${sharedMessage}`.trim() :
        confirmMessage;

      // A Bunny topic must go through deleteBunnyVideo (Finding 2): this
      // screen's own deleteOnlyVideo mutation only clears vdoLength and
      // vdoStreamPath and never touches bunnyVideoGuid, which would leave the
      // video sitting in Bunny forever while the UI reports success. This
      // matters here specifically because a topic on this screen can hold a
      // Bunny video it borrowed from a topic on the Bunny screen, even though
      // this screen never uploads to Bunny itself.
      const topic = this.vdoSetTopicEdit.selectedVdoSetTopic;
      if (topic && topic.bunnyVideoGuid) {
        confirmDelete(this.$vs, this.removeBunnyVideo, payload, finalMessage);
        return;
      }
      confirmDelete(this.$vs, this.removeVdoSetTopicVideo, payload, finalMessage);
    },
    onPreviewVideoClick(selectedData){
      this.onEditClick(selectedData);
      this.onTriggerPreviewClick(true);
    },
    onTriggerPreviewClick(trigger) {
      this.showPreviewVideo = trigger;
    },
    onDownloadVideoClick(vdoSetTopic) {
      this.loading = true;
      const streamPath = vdoSetTopic.vdoStreamPath;
      const url = `${config.url.downloadVideo}/${getECode}/${getRStage}/${streamPath}`;

      axios.get(url, {responseType: 'blob'})
        .then(response => {
          let fileNameSplit = streamPath.split('/');
          fileNameSplit = fileNameSplit[fileNameSplit.length - 1].split('.');
          const fileExtension = fileNameSplit[fileNameSplit.length - 1];
          const subjectCode = this.vdoSetEdit.courseOutline.subjectCode;
          const unitSeq = this.vdoSetUnitEdit.selectedVdoSetUnit.unitSeq;
          const topicNo = vdoSetTopic.no
          const topicName = vdoSetTopic.nameLocal
          const fileName = `${subjectCode}_${unitSeq}_${topicNo}_${topicName}.${fileExtension}`;

          const blob = new Blob([response.data], {type: 'video/*'});
          const link = document.createElement('a');
          link.href = URL.createObjectURL(blob);
          link.download = fileName;
          link.click();
          URL.revokeObjectURL(link.href);
        }).finally(() => {
        this.loading = false;
      });
    },
    async onFileUploadChange(file) {
      // const reader = new FileReader();
      // const _this = this;
      // reader.onloadend = async () => {
      //   // Get the file content as a binary string
      //   const arrayBuffer = reader.result;
      //   console.log('arrayBuffer:', arrayBuffer);
      //
      //   // const checksum = CryptoJS.MD5(CryptoJS.enc.Latin1.parse(arrayBuffer)).toString(CryptoJS.enc.Base64);
      //   // console.log('checksum crypto js:', checksum);
      //   // _this.uploadPayload.checksum = checksum;
      //
      //   const checksum = CryptoJS.MD5(CryptoJS.enc.Latin1.parse(arrayBuffer)).toString(CryptoJS.enc.Base64);
      //   console.log('checksum crypto js:', checksum);
      //   _this.uploadPayload.checksum = checksum;
      //
      //
      //   // const hash = crypto.createHash('md5');
      //   // hash.update(arrayBuffer);
      //   // const hex = hash.digest('hex');
      //   // console.log('hex:', hex);
      //
      //   // Calculate SHA-256 checksum using SubtleCrypto
      //   // const hashBuffer = await crypto.subtle.digest('md5', arrayBuffer);
      //   //
      //   // // Convert ArrayBuffer to hexadecimal string
      //   // const hashArray = Array.from(new Uint8Array(hashBuffer));
      //   // const hashHex = hashArray.map(byte => byte.toString(16).padStart(2, '0')).join('');
      //   //
      //   // // Log the checksum (you can use it however you need)
      //   // console.log('Checksum (md5):', hashHex);
      // };
      //
      // reader.readAsArrayBuffer(file);

      await this.setVdoInfo(file, this.uploadPayload);
      if (this.uploadPayload.vdoLength === null || this.uploadPayload.vdoLength === undefined || this.uploadPayload.vdoLength <= 0) {
        showLocalNotification(this.$vs, this.$t('general.error')
          , this.$t('upload.upload-vdo-fail', {fileName: this.uploadPayload.fileName})
          , notificationType.ERROR);
        this.local.isUploading = false;
        this.$refs['myVueDropzone'].removeAllFiles(true);
      }
    },
    async onUploadSuccess(file) {
      //call update function
      const response = JSON.parse(file.xhr.response);
      this.uploadPayload.fileName = `${response.original.path}/${response.original.name}`;
      await this.updateVdoLength();

      showLocalNotification(this.$vs, this.$t('general.success')
        , this.$t('upload.upload-vdo-success', {fileName: this.uploadPayload.fileName})
        , notificationType.SUCCESS);
      this.local.isUploading = false;
      this.$refs['myVueDropzone'].removeAllFiles();
    },
    onUploadError(file, err) {
      let message = err;
      if (err.includes('writeStream')) {
        message = 'ไฟล์วิดีโอมีการใช้งานอยู่ กรุณาลองใหม่อีกครั้ง';
      }
      showLocalNotification(
        this.$vs
        , this.$t('general.error')
        , this.$t('upload.upload-vdo-fail', {fileName: this.uploadPayload.fileName}) + ' ' + message
        , notificationType.ERROR);
      this.local.isUploading = false;
      this.$refs['myVueDropzone'].removeAllFiles();
    },
    sendingEvent(file, xhr, formData) {
      this.local.isUploading = true;
      // move set vdo info to onFileUploadChange
      // this.setVdoInfo([file], this.uploadPayload);
      for (let key in this.uploadPayload) {
        formData.append(key, this.uploadPayload[key]);
      }
      formData.append('vdoSetCode', this.vdoSetInfo.selectedVdoSet.code);
      formData.append('unitSeq', this.vdoSetUnitEdit.selectedVdoSetUnit.unitSeq);
      formData.append('no', this.form.vdoSetTopicInput.no);
      // console.log('this.uploadPayload.checksum:', this.uploadPayload.checksum);
      // formData.append('checksum', this.uploadPayload.checksum);
    },
    // upload learn time function
    onUploadLearnTimeClick(){
      this.showUploadLearnTime = true;
    },
    closeUploadLearnTimeCard(){
      this.showUploadLearnTime = false
    },
    async uploadPictureChange(e) {
      if (e.target.files && e.target.files.length > 0) {
        let file = e.target.files[0];

        //500000 b = 500 kb
        if(file.size >= 500000){
          showLocalNotification(this.$vs
            , this.$t('general.warning')
            , this.$t('course-outline.file-to-large')
            , notificationType.WARNING)
          file = null;
          return;
        }

        let reader = new FileReader();
        reader.readAsDataURL(file);
        const _this = this
        reader.onload =  async function(evt) {
          let img = new Image();
          img.onload = async () => {
            //check image resolution
            if(img.width !== _this.allowWidth || img.height !== _this.allowHeight) {
              showLocalNotification(_this.$vs
                , _this.$t('general.warning')
                , _this.$t('general.wrong-image-resolution')
                , notificationType.WARNING)
              file = null;
              return;
            }

            _this.fileUpload = file
            //do upload
            let uploadPayload = {
              file: file,
              operationName: config.operationName.coverPhoto,
            }
            let resultUpload = await _this.uploadAvatar(uploadPayload);

            if (resultUpload) {
              await _this.updateAfterUploadThumbnail(resultUpload.file.uuid);
            }

          }
          img.src = evt.target.result;
        }

      } else {
        this.fileUpload = null;
        this.form.vdoSetTopicInput.thumbnail = '';
      }
    },
    async onCheckVideoCorrupt(vdoStreamPath){
      try {
        this.loading = true;

        const {data} = await axios.post(config.url.checkVideoCorrupt,
          {
            filePath: vdoStreamPath
          }, {
            headers: {
              'Content-Type': 'application/json',
              'authorization': getToken,
            }
          }
        )

        if (data.corrupt === null) {
          await warningDialog(this.$vs, data.message);
        } else if (data.corrupt === false) {
          await successDialog(this.$vs, data.message);
        } else if (data.corrupt === true) {
          await errorDialog(this.$vs,  data.message);
        }

      } catch (e) {
        showLocalNotification(this.$vs, this.$t('general.error'), e.message, notificationType.ERROR);
      } finally {
        this.loading = false;
      }
    },
    //---------------------------------------- Local Function ------------------------------------------------------//
    async saveVdoSetTopic(payload) {
      let result;
      if (!payload.id) {
        result = await this.addVdoSetTopic(payload);
      } else {
        result = await this.updateVdoSetTopic(payload);
      }

      if (result) {
        this.updateListAfterSave(payload, result);
      }

    },
    async removeVdoSetTopic(payload) {
      let result = await this.deleteVdoSetTopic(payload);

      // remove list
      if (result) {
        this.updateListAfterDelete(result);
      }else{
        showLocalNotification(this.$vs, this.$t('general.warning')
          , this.$t('vdo-set-topic.can-not-delete')
          , notificationType.WARNING);
      }

    },
    async removeVdoSetTopicVideo(payload) {
      let result = await this.deleteOnlyVideo(payload);

      // remove list
      if (result) {
        this.updateListAfterSave(payload, result);
      }else{
        showLocalNotification(this.$vs, this.$t('general.warning')
          , this.$t('vdo-set-topic.can-not-delete')
          , notificationType.WARNING);
      }

    },
    // Bunny counterpart of removeVdoSetTopicVideo (Finding 2), mirroring
    // VdoSetTopicEditBunny.vue's method of the same name. The response only
    // carries the Bunny TOPIC_FIELDS subset plus vdoSet/vdoSetUnit
    // totalVdoLength -- not the full topic shape -- so the topic itself is
    // applied through applyBunnyTopic rather than updateListAfterSave, which
    // expects the full shape and would throw on the missing fields.
    async removeBunnyVideo(payload) {
      const topic = this.vdoSetTopicEdit.selectedVdoSetTopic;
      const updated = await this.deleteBunnyVideo(payload.id);

      if (updated) {
        // Applied to both the selection and its entry in the unit's topic
        // list, so the left-hand list row does not keep showing the deleted
        // video's length until the admin navigates away and back.
        const targets = [];
        if (topic) targets.push(topic);
        const list = this.vdoSetUnitEdit.selectedVdoSetUnit
          ? this.vdoSetUnitEdit.selectedVdoSetUnit.vdoSetTopics
          : [];
        const listEntry = list.find(item => item.id === payload.id);
        if (listEntry && !targets.includes(listEntry)) targets.push(listEntry);
        targets.forEach(target => this.applyBunnyTopic(target, updated));

        this.setTotalVdoLength(updated);
        showLocalNotification(this.$vs, this.$t('general.success')
          , this.$t('notification.delete-item-success-message', {value: updated.nameLocal})
          , notificationType.SUCCESS);
      } else {
        showLocalNotification(this.$vs, this.$t('general.warning')
          , this.$t('vdo-set-topic.can-not-delete')
          , notificationType.WARNING);
      }
    },
    // Writes a deleteBunnyVideo response's Bunny fields onto the topic object
    // the screen is rendering. Copied from VdoSetTopicEditBunny.vue's method
    // of the same name -- this screen has no polling of its own to keep in
    // sync with, only this one write after a delete.
    applyBunnyTopic(topic, updated) {
      if (!topic) return;
      this.$set(topic, 'videoProvider', updated.videoProvider);
      this.$set(topic, 'bunnyVideoGuid', updated.bunnyVideoGuid);
      this.$set(topic, 'bunnyStatus', updated.bunnyStatus);
      this.$set(topic, 'bunnyStatusAt', updated.bunnyStatusAt);
      this.$set(topic, 'vdoLength', updated.vdoLength);
      this.$set(topic, 'playbackUrl', updated.playbackUrl);
      this.$set(topic, 'playbackStatus', updated.playbackStatus);
    },
    async updateVdoLength() {
      let payload = {
        id: this.vdoSetTopicEdit.selectedVdoSetTopic.id,
        teacherId: this.vdoSetEdit.courseOutline.teacher.id,
        vdoSetTopicInput: {
          vdoLength: parseInt(this.uploadPayload.vdoLength.toFixed(0)),
          vdoStreamPath: this.uploadPayload.fileName,
        }
      };
      let result = await this.updateVdoSetTopic(payload);

      if (result) {
        this.updateListAfterSave(payload, result);
      }
    },
    async updateAfterUploadThumbnail(thumbnail){
      let payload = {
        id: this.vdoSetTopicEdit.selectedVdoSetTopic.id,
        teacherId: this.vdoSetEdit.courseOutline.teacher.id,
        vdoSetTopicInput: {
          thumbnail: thumbnail,
        }
      };
      let result = await this.updateOnlyVdoSetTopic(payload);

      if (result) {
        this.form.vdoSetTopicInput.thumbnail = thumbnail;
        this.updateListAfterSave(payload, result);
      }
    },
    // The only duration this form is allowed to send. vdoLength is not an
    // editable field here -- no input binds to it; it is written by an upload,
    // by the Bunny sync, and by borrowVdoSetTopicVideo, all server-side.
    // onEditClick still copies it into the form, and prepareDataBeforeSave
    // used to send that copy straight back on every save, so a save that
    // followed a borrow overwrote the borrowed video's duration with whatever
    // the topic held when it was selected -- 0 for a topic that had no video
    // yet. That is how EDC 5102-002 ended up with units reading
    // "2 วิดีโอ รวมเวลา 00:00:00": the videos are there, their lengths were
    // saved away. So the value goes out only when this very save carries a
    // freshly measured upload; otherwise the field is left off entirely and
    // the stored length stands.
    measuredVdoLength() {
      return this.uploadPayload.vdoLength > 0 ? this.uploadPayload.vdoLength : null;
    },
    prepareDataBeforeSave() {
      delete this.form.vdoSetTopicInput.vdoStreamPath;

      let payload = {
        teacherId: this.vdoSetEdit.courseOutline.teacher.id,
        //set vdo duration here -- only when THIS save carries a new upload
        vdoSetTopicInput: withVdoLength(this.form.vdoSetTopicInput, this.measuredVdoLength()),
      };
      if (this.vdoSetTopicEdit.selectedVdoSetTopic && this.vdoSetTopicEdit.selectedVdoSetTopic.id) {
        //edit
        payload['id'] = this.vdoSetTopicEdit.selectedVdoSetTopic.id;
      } else {
        //insert
        payload['vdoSetId'] = this.vdoSetInfo.selectedVdoSet.id;
        payload['vdoSetUnitId'] = this.vdoSetUnitEdit.selectedVdoSetUnit.id;
        payload['courseOutlineId'] = this.vdoSetEdit.courseOutline.id;
      }

      return payload
    },
    setVdoLengthLabel(vdoLength) {
      let totalVdoLength = '00:00:00';
      if (vdoLength) {
        totalVdoLength = secondToHHMMSSFormat(vdoLength);
      }
      return totalVdoLength;
    },
    setSelectedClass(item) {
      let selectedClass = '';
      if (this.vdoSetTopicEdit.selectedVdoSetTopic && item.id === this.vdoSetTopicEdit.selectedVdoSetTopic.id) {
        return 'text-primary'
      }
      return selectedClass;
    },
    updateListAfterSave(payload, result) {
      //deep copy so we can mutate data
      result = JSON.parse(JSON.stringify(result));
      if (!payload.id) {
        //add new vdoSetTopic to vdoSetTopics list
        this.vdoSetUnitEdit.selectedVdoSetUnit.vdoSetTopics.push(result);

        //add new vdoSetUnit to vdoSets list
        const index = this.vdoSetInfo.selectedVdoSet.vdoSetUnits.findIndex(item => {
          return item.id === this.vdoSetUnitEdit.selectedVdoSetUnit.id
        });
        this.vdoSetInfo.selectedVdoSet.vdoSetUnits[index] = this.vdoSetUnitEdit.selectedVdoSetUnit

        this.onAddClick();
      } else {
        //update new vdoSetTopic to vdoSetUnis list
        const index = this.vdoSetUnitEdit.selectedVdoSetUnit.vdoSetTopics.findIndex(item => {
          return item.id === result.id
        });
        this.vdoSetUnitEdit.selectedVdoSetUnit.vdoSetTopics[index] = result;

        //add new vdoSetUnit to vdoSets list
        const indexUnit = this.vdoSetInfo.selectedVdoSet.vdoSetUnits.findIndex(item => {
          return item.id === this.vdoSetUnitEdit.selectedVdoSetUnit.id
        });
        this.vdoSetInfo.selectedVdoSet.vdoSetUnits[indexUnit] = this.vdoSetUnitEdit.selectedVdoSetUnit;

        this.vdoSetTopicEdit.selectedVdoSetTopic = result;
      }
      this.setTotalVdoLength(result);
    },
    updateListAfterDelete(result) {
      //remove from list
      const index = this.vdoSetUnitEdit.selectedVdoSetUnit.vdoSetTopics.findIndex(item => item.id === result.id);
      this.vdoSetUnitEdit.selectedVdoSetUnit.vdoSetTopics.splice(index, 1);

      setEmptyVdoSetTopicForm();
      this.setTotalVdoLength(result);

    },
    setTotalVdoLength(result) {
      this.vdoSetUnitEdit.selectedVdoSetUnit.totalVdoLength = result.vdoSetUnit.totalVdoLength;
      this.vdoSetInfo.selectedVdoSet.totalVdoLength = result.vdoSet.totalVdoLength;
    },
    setVdoInfo(file, uploadPayload) {
      return new Promise((resolve) => {
        //set upload file name
        let fileExtension = file.name.split('.').pop();
        uploadPayload.fileName = file.name;
        uploadPayload.fileNameUpload = config.prefixFileName.vdoOnDemand
          + '_' + this.vdoSetEdit.courseOutline.subject.code
          + '_' + this.vdoSetEdit.courseOutline.teacher.code
          + '_' + this.vdoSetUnitEdit.selectedVdoSetUnit.unitSeq
          + '_' + this.vdoSetTopicEdit.selectedVdoSetTopic.no
          + '_' + this.vdoSetTopicEdit.selectedVdoSetTopic.id
          + '.' + fileExtension

        //set video info
        let video = document.createElement('video');
        video.src = URL.createObjectURL(file);
        video.preload = 'metadata';
        video.onloadedmetadata = async function () {
          window.URL.revokeObjectURL(video.src);
          uploadPayload.vdoLength = video.duration;
          resolve(video);
        }
      });
    },
    clearVideoUploadPayload() {
      this.uploadPayload.fileName = '';
      this.uploadPayload.fileNameUpload = '';
      this.uploadPayload.vdoLength = 0;
    },
    setTabDefaultPosition(){
      this.selectedTab = 0;
    },
    // async computeFileChecksum(file) {
    //   const objType = Object.prototype.toString.call(file);
    //   // console.log('objType', objType);
    //   const reader = new FileReader();
    //   reader.readAsArrayBuffer(file);
    //   reader.onloadend = function () {
    //     // console.log('onloadend')
    //     const hash = crypto.createHash('md5');
    //     hash.update(new Uint8Array(reader.result));
    //     const checksum = hash.digest('hex');
    //     // console.log('checksum', checksum);
    //     return hash.digest('hex');
    //   };
    //
    //   // const buffer = await file.arrayBuffer();
    //   // const hash = crypto.createHash('md5');
    //   // hash.update(new Uint8Array(buffer));
    //   // return hash.digest('hex');
    // }
    async loadSharing() {
      const topic = this.currentVdoSetTopic;
      if (!topic || !topic.id) {
        this.sharing = null;
        return;
      }
      this.sharing = await this.getVdoSetTopicSharing({id: topic.id});
    },
    async onBorrowSelected(sourceTopic) {
      const target = this.currentVdoSetTopic;
      if (!target || !target.id) return;

      this.loading = true;
      try {
        const result = await this.borrowVdoSetTopicVideo({
          targetVdoSetTopicId: target.id,
          sourceVdoSetTopicId: sourceTopic.id,
        });
        // A falsy result means the action hit a GraphQL error and already
        // committed it -- the error watcher raises that notification, so
        // there is nothing to do here but skip the list update.
        if (result) {
          // updateListAfterSave(payload, result) -- it only reads payload.id, to
          // tell an insert from an update. Borrowing always targets an existing
          // topic, so the id is always present and it takes the update branch.
          this.updateListAfterSave({id: target.id}, result);
          await this.loadSharing();
        }
      } finally {
        this.loading = false;
      }
    },
    // The extra sentence a Delete confirmation needs when the file is shared:
    // without it an admin reads "delete" as "the video is gone", which for a
    // shared file is not what happens.
    sharedDeleteMessage() {
      const count = this.sharing && this.sharing.videoSharedWith ?
        this.sharing.videoSharedWith.length : 0;
      if (!count) return null;
      return this.$t('video-reuse.delete-shared-warning', {count});
    },
  },
}
</script>

<style scoped>

</style>
